var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"ds-calendar-icon",style:(_vm.stylesObject),attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.code)}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }